const CarouselArtworks = (color: string) => {
  return (
    <svg
      className="w-full h-full"
      viewBox="0 0 1000 653"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="105.263"
        y="80.8604"
        width="894.737"
        height="571.93"
        rx="44.2197"
        fill="currentColor"
        className={color}
      />
      <rect
        x="20"
        y="20.1582"
        width="854.737"
        height="531.93"
        rx="24.2197"
        fill="black"
      />
      <rect
        x="20"
        y="20.1582"
        width="854.737"
        height="531.93"
        rx="24.2197"
        stroke="white"
        strokeWidth="40"
      />
      <rect
        x="20"
        y="20.1582"
        width="854.737"
        height="531.93"
        rx="24.2197"
        stroke="white"
        strokeWidth="40"
      />
      <rect
        x="20"
        y="20.1582"
        width="854.737"
        height="531.93"
        rx="24.2197"
        stroke="white"
        strokeWidth="40"
      />
      <path
        d="M203.509 437.585L388.092 272.749C388.514 272.373 389.151 272.373 389.572 272.749L444.409 321.72C444.831 322.096 445.468 322.096 445.89 321.72L611.397 173.919C611.818 173.542 612.455 173.542 612.877 173.919L722.807 272.088"
        stroke="white"
        strokeWidth="38.8889"
        strokeLinecap="round"
      />
      <circle
        cx="229.824"
        cy="184.369"
        r="53.5965"
        stroke="white"
        strokeWidth="36.6667"
      />
    </svg>
  )
}

export default CarouselArtworks
